import { render, staticRenderFns } from "./Wap_WDD008_Step3.vue?vue&type=template&id=edfe9c86&scoped=true&"
import script from "./Wap_WDD008_Step3.vue?vue&type=script&lang=js&"
export * from "./Wap_WDD008_Step3.vue?vue&type=script&lang=js&"
import style0 from "./Wap_WDD008_Step3.vue?vue&type=style&index=0&id=edfe9c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe9c86",
  null
  
)

export default component.exports